import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { HttpService } from 'src/app/modules/shared/services/http.service';
import { Observable, map, tap } from 'rxjs';
import { OpportunityAddEditM } from '../models/opportunity-add-edit.models';
import { SavedFilterData } from 'src/app/modules/shared/models/filter.model';
import { GelAllOpportunityRequestModel, GetAllOpportunityGroupByRequest } from '../models/opportunity-list.model';
import { IQuotationList } from '../components/quotation-listing/model/quotation-list.model';

@Injectable({
    providedIn: 'root'
})
export class OpportunitiesService {

    appUrl = "";
    appCore = "";
    opportunityUrl:string;

    constructor(
        private httpService: HttpService,
        private http: HttpClient
        ) {
        this.opportunityUrl = environment.opportunityUrl;
        this.appCore = environment.baseUrl + "LionO360ApplicationLionOCoreAPI/LionO360/2.0/API/";
        this.appUrl = environment.opportunityUrl + "Opportunity/";
    }

    addOpportunity(opportunityData: OpportunityAddEditM, isBaseCurrency: boolean) {
        return this.http.post<any>(`${this.opportunityUrl}Opportunity?isBaseCurrency=${isBaseCurrency}`, opportunityData);
    }

    updateOpportunity(opportunityData: OpportunityAddEditM, isBaseCurrency: boolean) {
        return this.http.put<any>(`${this.opportunityUrl}Opportunity?isBaseCurrency=${isBaseCurrency}`, opportunityData);
    }

    getStages(data:{
        accountChannelId:number,
        channelId:number,
        isActive:boolean,
        Filter:string | null,
    }) {
        return this.http.get(`${this.opportunityUrl}Opportunity/v2/StageWiseCount/Channel/${data?.channelId}?IsActive=${data?.isActive}&accountChannelId=${data?.accountChannelId}&Filter=${data?.Filter}`);
    }

    getStageList(moduleId: number, channelId: number, includeClosedStages: boolean = true) {
        const params = new HttpParams();
        if(!includeClosedStages){
            params.set('includeClosedStages', false);
        }
        return this.http.get<any>(`${environment.configUrlV2}/Stage/SelectList/Module/${moduleId}/Channel/${channelId}`, {params});
    }

    getAllOpportunities(data:GelAllOpportunityRequestModel){
        return this.httpService.create(`${this.opportunityUrl}Opportunity/v2/GetPagedList`,data);
    }

    getOpportunityListWithFilters(requestModel: GelAllOpportunityRequestModel){
        return this.httpService.create(`${this.opportunityUrl}Opportunity/v2/GetPagedListWithFilter`, requestModel);
    }

    getOpportunityGroupList(requestModel: GetAllOpportunityGroupByRequest){
        return this.httpService.create(`${this.opportunityUrl}Opportunity/v2/GetGroupedPagedList`, requestModel);
    }

    getPagedListKanban(data:GelAllOpportunityRequestModel){
        return this.http.post(`${this.opportunityUrl}Opportunity/v2/GetPagedListKanban`,data);
    }

    getOpportunityById(id,includeDeleted: boolean = false){
        let params = new HttpParams();
        if(includeDeleted){
            params = params.append('includeDeleted', true);
        }
        return this.http.get(`${this.opportunityUrl}Opportunity/V2/${id}`,{params});
    }

    getOpportunityMLAIScore(opportunityId: number) {
        return this.http.get(`${environment.mlAPI}Scoring/opportunity/${opportunityId}`);
    }

    // getOpportunityStageReasonComment(organizationId, opportunityId, stageId) {
    //     return this.http.get<any>(this.opportunityUrl + 'Opportunity/GetStageReasonComment?organizationId=' + organizationId + '&opportunityId=' + opportunityId + '&stageId=' + stageId);
    // }

    getLeadStageReasonComment(organizationId, userId, opportunityId, stageId) {
        let url = this.appUrl + 'GetStageReasonComment?organizationId=' + organizationId + '&opportunityId=' + opportunityId + '&stageId=' + stageId;
        return this.http.get<any>(url, {
            headers: new HttpHeaders({
                "userId": `${userId}`,
                "organizationId": `${organizationId}`
            })
        })
            .toPromise()
            .then(res => res);
    }

    getAllSources(companyID: number) {
        return this.http.get<any>(this.appCore + 'Source', {
            params: new HttpParams().append("organizationId", companyID.toString())
        });
    }

    getAllRatings() {
        return this.http.get<any>(this.appCore + 'Rating');
    }

    deleteOpportunity(id): Observable<any> {
        return this.http.delete<any>(this.opportunityUrl + 'Opportunity/' + id);
    }

    saveFilterDataChannalWise(data: {moduleId: number, channelId: number , filterData: SavedFilterData}){
        return this.http.post<any>(`${environment.configUrlV2 + "/ColumnFilter/"}Module/${data?.moduleId}/Channel/${data?.channelId}`, data?.filterData);
    }

    getSavedFilterDataChannalWise(data: {moduleId: number, channelId: number}){
        return this.http.get<any>(`${environment.configUrlV2 + "/ColumnFilter/"}Module/${data?.moduleId}/Channel/${data?.channelId}`);
    }

    resetSavedFilterChannelWise(data: {moduleId: number, channelId: number}){
        return this.http.delete<any>(`${environment.configUrlV2 + "/ColumnFilter/ResetFilter/"}Module/${data?.moduleId}/Channel/${data?.channelId}`);
    }

    resetSavedGroupByChannelWise(data: {moduleId: number, channelId: number}){
        return this.http.delete<any>(`${environment.configUrlV2 + "/ColumnFilter/ResetGroupBy/"}Module/${data?.moduleId}/Channel/${data?.channelId}`);
    }

    /** Opportunity to Quotation */

    getQuotationListByOpportunityId(opportunityId: number,pageNumber: number,IsAscending: boolean,pageSize: number,searchColumns: string,SearchValue: string)
    : Observable<{ IQuotationList: IQuotationList[]; headers: any }> {
        SearchValue = SearchValue ? SearchValue : '';
        let params = new HttpParams().append('PageNumber', pageNumber).append('PageSize', pageSize).append('IsAscending', IsAscending).append('SearchColumns', searchColumns).append('SearchValue', SearchValue);
        return this.http
          .get<IQuotationList[]>(`${environment.inventorySalesUrl}Quotation/${opportunityId}`, { observe: 'response', params })
          .pipe(
            map((res: HttpResponse<IQuotationList[]>) => {
              return {
                IQuotationList: res.body || [],
                headers: JSON.parse(res.headers.get('x-pagination') || '{}')
              };
            })
          );
      }
      
    getOpportunityByAccountId(accountId: number, filter: string, incluDeleted:boolean): Observable<any> {
        return this.http.get<any>(`${this.opportunityUrl}Opportunity/V2/OpportunityByAccount?accountId=${accountId}&filter=${filter}&includeDeleted=${incluDeleted}`, {});
    }
    getApprovedEstimateByOpportunityId(opportunityId: number, pageNumber: number,IsAscending: boolean,pageSize: number,searchColumns: string,SearchValue: string) {
        let params = new HttpParams().append('PageNumber', pageNumber).append('PageSize', pageSize).append('IsAscending', IsAscending).append('SearchColumns', searchColumns).append('SearchValue', SearchValue);
        return this.http
        .get<any[]>(`${environment.inventorySalesUrl}Quotation/ApprovedEstimateByOpportunity?opportunityId=${opportunityId}`, { observe: 'response', params })
        .pipe(
            map((res: HttpResponse<any[]>) => {
              return {
                data: res.body || [],
                headers: JSON.parse(res.headers.get('x-pagination') || '{}')
              };
            })
          );
    }
    syncQuotationToOpportunity(opportunity, opportunityId: number): Observable<any> {
        return this.http.patch<any>(`${this.opportunityUrl}Opportunity/V2/FieldWithProducts/${opportunityId}`, opportunity);
    }
}
